import { useAuth } from "@clerk/clerk-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { opsHead } from "~/head";

export const Route = createFileRoute("/sign-out")({
  head: () => opsHead("Sign Out"),
  component: View,
});

function View() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    signOut().then(() => {
      navigate({ to: "/sign-in" });
    });
  }, [signOut, navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      Signing out...
    </div>
  );
}
